/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './order.module.scss'
import Management from './managememnt';
import { ReservedOrderInfoContext } from './contexts/reservedOrderInfo';
import { TReservedOrderDetails } from '../../../../../states/reservedOrdersState/models/reservedOrderDetails';
import Price from './price';
import Time from './time';
import BusinessName from './businessName';
import DataTime from './dataTime';
import MapBox from './mapBox';
import Locations from './locations';
import { useThemeMode } from '../../../../../states/contexts/theme';
interface Props {
    reservedOrderInfo: TReservedOrderDetails
}
const Order: React.FC<Props> = ({ reservedOrderInfo }) => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer

    return (
        <ReservedOrderInfoContext.Provider value={reservedOrderInfo}>
            <section className={styles.order} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                <div className={styles.header}>
                    <BusinessName />
                    <div className={styles.times}>
                        <DataTime />
                        <Time />
                    </div>
                </div>
                <hr />
                <div className={styles.content}>
                    <div className={styles.map_box}><MapBox /></div>
                    <Price />
                    <Locations />
                </div>
                <div className={styles.management_part}>
                    <Management />
                </div>
            </section>
        </ReservedOrderInfoContext.Provider>
    )
}

export default Order;